<template>
  <v-layout row wrap>
    <v-col cols :sm="12" class="pa-0">
      <v-card v-show="!Account.isForm" flat class="pa-2 text-no-wrap">
        <v-data-table
          dense
          must-sort
          fixed-header
          item-key="id"
          :items="Account.list"
          :options.sync="pagings"
          :headers="cTableHeaders"
          :server-items-length="Account.total"
          :items-per-page="Account.filter.limit"
          :footer-props="{ itemsPerPageOptions: Account.itemPages }"
          :item-class="(e) => (id == e.id ? 'primary lighten-5' : '')"
        >
          <template v-slot:top>
            <v-layout px-2 justify-space-around align-end>
              <v-layout align-center>
                <h2>{{ $t("menu.account") }}</h2>
                <v-btnc
                  :size="30"
                  icon="mdi-plus"
                  @click="
                    fnCallCreateView(model);
                    _fnLoadData();
                  "
                  v-if="fnCheckMission(Session, [{ m: ACCOUNT, p: CREATE }])"
                />
              </v-layout>
              <v-spacer />
              <div class="mb-3" :style="{ width: '250px' }">
                <v-text-field
                  dense
                  single-line
                  hide-details
                  v-model="Account.search"
                  @keydown.enter="_fnSearch"
                  :placeholder="$t(`table.search`)"
                />
              </div>
            </v-layout>
          </template>
          <template #[`item.createdAt`]="{ item }">
            <v-btnc
              color="warning"
              icon="mdi-pencil"
              @click="
                fnCallUpdateView({ model, item: item });
                _fnLoadData();
              "
              v-if="fnCheckMission(Session, [{ m: ACCOUNT, p: UPDATE }])"
            />
            <v-btnc
              color="error"
              icon="mdi-delete"
              @click="fnCallDeleteView({ model, item: item })"
              v-if="fnCheckMission(Session, [{ m: ACCOUNT, p: DELETE }])"
            />
            <v-btnc
              color="teal white--text"
              icon="mdi-lock-reset"
              @click="_fnResetPassword(item)"
              v-if="fnCheckMission(Session, [{ m: ACCOUNT, p: UPDATE }])"
            />
          </template>
          <template #[`item._id`]="{ item }"> {{ item.id }}<br /> </template>
          <template #[`item.role`]="{ item }">
            {{ item.role.name }}
          </template>
          <template #[`item.status`]="{ item }">
            <span
              :class="
                item.status.id == '5ed349fde6278057e83adfde'
                  ? 'success--text'
                  : 'error--text'
              "
            >
              {{ item.status.name }}
            </span>
          </template>
          <template #[`item.updatedBy`]="{ item }">
            {{ item.updatedBy.name }}
          </template>
          <template #[`item.updatedAt`]="{ item }">
            {{ item.updatedAt | mDateTime }}
          </template>
        </v-data-table>
      </v-card>
    </v-col>
    <v-col cols :sm="12" class="pa-0"><v-dialog /></v-col>
    <v-reset-pass v-model="isShowResetPass" />
  </v-layout>
</template>

<script>
import Dialog from "./dialog.vue";
import ResetPass from "./resetPass.vue";

export default {
  components: {
    "v-dialog": Dialog,
    "v-reset-pass": ResetPass,
  },
  data() {
    return {
      id: "",
      model: "Account",
      pagings: {},
      isShowResetPass: false,
    };
  },
  computed: {
    cTableHeaders() {
      let table = [
        {
          text: this.$t(`table.action`),
          sortable: false,
          value: "createdAt",
          width: "10px",
        },
        {
          text: this.$t(`table.id`),
          value: "_id",
          width: "10px",
        },
        {
          text: this.$t(`table.name`),
          value: "name",
        },
        {
          text: this.$t(`table.role`),
          value: "role",
          width: "10px",
        },
        {
          text: this.$t(`table.status`),
          value: "status",
          width: "10px",
        },
        {
          text: this.$t(`table.updatedBy`),
          value: "updatedBy",
          width: "10px",
        },
        {
          text: this.$t(`table.updatedAt`),
          value: "updatedAt",
          width: "10px",
        },
      ];
      return table;
    },
  },
  watch: {
    "Account.isRefresh": function (val) {
      if (val) {
        this._fnCallListView();
      }
    },
    pagings: function (val) {
      const { itemsPerPage, page, sortBy, sortDesc } = val;
      this[this.model].filter.limit = itemsPerPage;
      this[this.model].filter.page = page;
      if (sortBy.length) {
        this[this.model].filter.sort = `${sortBy[0]}:${sortDesc[0] ? -1 : 1}`;
      }
      this._fnCallListView();
    },
  },
  methods: {
    _fnLoadData() {
      if (this[this.model].isCreate) {
        this[this.model].obj = {};
      } else if (this[this.model].isUpdate) {
        this.id = this[this.model].obj.id;
        this[this.model].obj = {
          ...this[this.model].obj,
          gender: this[this.model].obj.gender.id,
          status: this[this.model].obj.status.id,
          role: this[this.model].obj.role.id,
        };
      }
    },
    _fnCallListView() {
      this.fnCallListView({
        url: "/v1/admin/account",
        model: this.model,
      });
    },
    _fnSearch({ target: { value } }) {
      if (!value) delete this[this.model].filter.$text;
      else this[this.model].filter.$text = value;
      this._fnCallListView();
    },
    _fnBuild(items) {
      return items.map((e) => e.name).join(",");
    },
    _fnResetPassword(item) {
      this.isShowResetPass = true;
      this[this.model].obj = this.fnCopy(item);
    },
  },
};
</script>
